import React, { Component } from "react";
import PropTypes from "prop-types";
import { batch, connect } from "react-redux";
import { setActiveLayer, setActivePage } from "../_actions/textToolbarActions";
import { wsClonePage, wsDeletePage } from "../_actions/webSocketAction";
import { resetSliders } from "../_actions/sidebarSliderActions";
import { TldrConfirmActionModal } from "../_components/common/statelessView";
import { selectArtboard } from "../_actions/motionActions";
import { FaCopy, FaCut, FaEllipsisV, FaTrash } from "react-icons/fa";
import {
  Box,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
} from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import { checkArtboardLimit } from "../_utils/common";

class ArtBoardPreviewDropdownActions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showConfirmation: false,
    };
  }

  onClickDeleteCurrentArtBoard = (event) => {
    const { activePage, pagestore, showForActiveArtboardOnly, pageId } =
      this.props;
    if (activePage.isSelected || !showForActiveArtboardOnly) {
      let currentIndex = null;
      let pageIdToRemove = null;
      if (showForActiveArtboardOnly) {
        currentIndex = activePage.pageIndex;
        pageIdToRemove = activePage.id;
      } else {
        currentIndex = pagestore.pageIds.indexOf(pageId);
        pageIdToRemove = pageId;
        if (currentIndex < 0) {
          return;
        }
      }
      this.props.wsDeletePage(pageIdToRemove);
    }

    this.props.setActiveLayer(null, null, null, null);
    this.props.resetSliders();
  };

  duplicate = () => {
    const {
      activePage,
      showForActiveArtboardOnly,
      pageId,
      pagestore,
      subscription,
    } = this.props;

    const isAvailable = checkArtboardLimit(pagestore, subscription);
    if (!isAvailable) return;
    if (showForActiveArtboardOnly) {
      this.props.wsClonePage(activePage.id);
    } else {
      this.props.wsClonePage(pageId);
    }
  };

  render() {
    const {
      activePage,
      pageId,
      showForActiveArtboardOnly,
      showTimelineOptions,
      selectArtboard,
      t,
    } = this.props;

    return (
      <>
        <Menu isLazy>
          <MenuButton
            as={IconButton}
            icon={<FaEllipsisV color="gray.100" />}
            variant="unstyled"
          />
          <Portal>
            <MenuList zIndex="docked">
              <MenuItem
                icon={<FaCopy />}
                onClick={(e) => {
                  e.stopPropagation();
                  this.duplicate();
                }}
              >
                {t("duplicate")}
              </MenuItem>
              <MenuItem
                icon={<FaTrash />}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ showConfirmation: true });
                }}
              >
                {t("delete")}
              </MenuItem>
              {showTimelineOptions && (
                <MenuItem
                  icon={<FaCut />}
                  onClick={(e) => {
                    e.stopPropagation();
                    selectArtboard(pageId);
                  }}
                >
                  {t("adjust")}
                </MenuItem>
              )}
            </MenuList>
          </Portal>
        </Menu>
        <TldrConfirmActionModal
          show={this.state.showConfirmation}
          onYes={() => {
            batch(() => {
              this.setState({ showConfirmation: false });
              this.onClickDeleteCurrentArtBoard();
            });
          }}
          onHide={() => this.setState({ showConfirmation: false })}
        ></TldrConfirmActionModal>
      </>
    );
  }
}

ArtBoardPreviewDropdownActions.defaultProps = {
  showForActiveArtboardOnly: true,
  showTimelineOptions: false,
};

ArtBoardPreviewDropdownActions.propTypes = {
  pageId: PropTypes.string.isRequired,
  showForActiveArtboardOnly: PropTypes.bool,
  showTimelineOptions: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  pagestore: state.pagestore,
  subscription: state.subscription,
  activePage: state.editor.activePage,
});

const mapDispatchToProps = (dispatch) => ({
  setActivePage: (pageId, pageIndex, isSelected) =>
    dispatch(setActivePage(pageId, pageIndex, isSelected)),
  wsDeletePage: (pageId) => dispatch(wsDeletePage(pageId)),
  setActiveLayer: (elementId, elementType, layerId, elementParentId) =>
    dispatch(setActiveLayer(elementId, elementType, layerId, elementParentId)),
  resetSliders: () => dispatch(resetSliders()),
  wsClonePage: (pageId) => dispatch(wsClonePage(pageId)),
  selectArtboard: (id = null, idx = null) => dispatch(selectArtboard(id, idx)),
});

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(ArtBoardPreviewDropdownActions)
);
